<template>
  <div class="footbar">
    <div class="footbar-box">
      <div class="footbar-box-left">
        <img src="@/assets/logo.png" alt="">
      </div>
      <div class="footbar-box-right">
        <ul class="footbar-item">
          <li @click="gorouter('/market')">{{ $t('coin.market') }}</li>
          <li @click="gorouter('/spot')">{{ $t('coin.spot') }}</li>
          <li @click="gorouter('/futures')">{{ $t('coin.futures') }}</li>
        </ul>
        <div class="footbar-item">
          <li @click="gorouter('/news')">{{ $t('help.text') }}</li>
          <li @click="gorouter('/kefu')">Online Support</li>
        </div>
<!--        <div class="footbar-item ml">-->
<!--          <li>youxiang@163.com</li>-->
<!--        </div>-->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  methods: {
    gorouter(path) {
      this.$router.push(path); // 路由跳转
    }
  }
}
</script>

<style>
.footbar {
  width: 100%;
  background-color: #121212;
  color: #9b9b9e;
}

.footbar .footbar-box {
  flex: 2;
  width: 1240px;
  padding: 20px 20px 100px;
  display: flex;
  align-items: center;

  margin: auto;
}

.footbar .footbar-box .footbar-box-left img {
  width: 54px;
  height: auto;
}

.footbar .footbar-box .footbar-box-right {
  display: flex;
  justify-content: flex-start;
  flex: 1;
}

.footbar .footbar-box .footbar-box-right .footbar-item {
  margin-left: 110px;
  margin-top: 10px;
}

.footbar .footbar-box .footbar-box-right .footbar-item li {
  cursor: pointer;
  margin-top: 10px;
}

.footbar .footbar-box .footbar-box-right .footbar-item li:hover {
  color: #fff;
}

.ml {
  margin-left: auto !important;
}
</style>
